import { FC } from 'react'
import { FormattedMessage } from 'react-intl'
import { useNavigate } from 'react-router'

import { Button, Image, Result } from 'antd'
import { useResponsive } from 'antd-style'

import imgSrc from '../components/icon/assets/not-found.svg'
import { Page } from '../components/page'
import { Title } from '../components/text/Title'
import routes from '../routes'

const NotFound: FC = () => {
  const navigate = useNavigate()
  const { mobile } = useResponsive()
  return (
    <Page>
      <Result
        icon={<Image preview={false} src={imgSrc} width={mobile ? 240 : 360} />}
        title={
          <Title level={1}>
            <FormattedMessage id={'not-found.title'} />
          </Title>
        }
        subTitle={<FormattedMessage id={'not-found.description'} />}
        extra={
          <Button onClick={() => (history.length > 2 ? navigate(-1) : navigate(routes.home))}>
            <FormattedMessage id={'not-found.go-back'} />
          </Button>
        }
      />
    </Page>
  )
}

export { NotFound as default }
